import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=97d8530c&scoped=true"
import script from "./Members.vue?vue&type=script&lang=js"
export * from "./Members.vue?vue&type=script&lang=js"
import style0 from "./Members.vue?vue&type=style&index=0&id=97d8530c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d8530c",
  null
  
)

export default component.exports